import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ConfiguratorComponent } from './configurator/configurator.component';
import { CalendarDetailsComponent } from './calendar-details/calendar-details.component';
import { TermsandconditionsComponent } from './termsandconditions/termsandconditions.component';
import { PagenotfoundComponent } from './pagenotfound/pagenotfound.component';

const routes: Routes = [
//  {path: '', canActivate: [ TermsandconditionsComponent ], component: ConfiguratorComponent },
  {path: '', component: ConfiguratorComponent },
  {path: 'calendar', component: CalendarDetailsComponent},
  // {path: '**', component: PagenotfoundComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [TermsandconditionsComponent]
})
export class AppRoutingModule { }
